// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'
import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Series} Series
 */

/**
 * @type {function(PlottrState): (Series | Null)}
 */
export const seriesSelector = createSelector(fullFileStateSelector, ({ series }) => {
  return series || null
})
/**
 * @type {function(PlottrState): String}
 */
export const seriesNameSelector = createSelector(seriesSelector, (series) => {
  if (series) {
    return series.name
  } else {
    return 'Untitled'
  }
})
/**
 * @type {function(PlottrState): String}
 */
export const seriesPremiseSelector = createSelector(seriesSelector, (series) => {
  if (series) {
    return series.premise
  } else {
    return ''
  }
})
/**
 * @type {function(PlottrState): String}
 */
export const seriesGenreSelector = createSelector(seriesSelector, (series) => {
  if (series) {
    return series.genre
  } else {
    return ''
  }
})
/**
 * @type {function(PlottrState): String}
 */
export const seriesThemeSelector = createSelector(seriesSelector, (series) => {
  if (series) {
    return series.theme
  } else {
    return ''
  }
})
